import React from 'react';
import ServiceCard from './ServiceCard';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-tooth',
      title: 'General Dentistry',
      description: 'Routine checkups, cleanings, and preventive care for a healthy smile.',
      items: [
        'Dental Extractions',
        'Fillings, Scaling & Polishing',
        'Diabetic dental care',
        'Dental Checkups'
      ]
    },
    {
      icon: 'fas fa-magic',
      title: 'Restorative & Prosthetic',
      description: 'Restore the function and appearance of your teeth with durable solutions.',
      items: [
        'Dental Crowns & Bridges',
        'Implants (Ceramic/Metal)',
        'Flexible Full & Partial Dentures',
        'Implant Supported Dentures'
      ]
    },
    {
      icon: 'fas fa-smile',
      title: 'Orthodontics & Aesthetic',
      description: 'Enhance your smile with straightening and cosmetic improvements.',
      items: [
        'Metal & Ceramic Braces',
        'Aligning & Closing Gaps',
        'Teeth Whitening',
        'Dental Veneers & Jewelry'
      ]
    },
    {
      icon: 'fas fa-syringe',
      title: 'Oral Surgery',
      description: 'Expert surgical care for complex dental conditions and trauma.',
      items: [
        'Wisdom Tooth Removal',
        'Oral Cancer Detection',
        'Facial Trauma Management',
        'Dental Implants'
      ]
    }
  ];

  return (
    <section className="py-12 md:py-24 bg-slate-50 dark:bg-slate-900/50 relative overflow-hidden" id="services">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-primary/5 to-transparent pointer-events-none"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-primary font-bold tracking-widest uppercase text-xs mb-3 block">
            Our Expertise
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-6">
            Comprehensive Dental Solutions
          </h2>
          <div className="w-20 h-1 bg-secondary mx-auto mb-8 rounded-full"></div>
          <p className="text-lg text-slate-600 dark:text-slate-400 font-light leading-relaxed">
            From routine checkups to complex surgeries, we provide a wide range of treatments <br className="hidden md:block" /> tailored to your smile using the latest technology.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}

          {/* Premium Root Canal Card - Stretched to fill grid if needed or stand out */}
          <div className="group relative bg-white dark:bg-slate-800 p-8 rounded-2xl shadow-soft hover:shadow-glow transition-all duration-300 border border-slate-100 dark:border-slate-700 md:col-span-2 lg:col-span-2 overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-secondary/10 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-150 duration-700"></div>

            <div className="flex flex-col md:flex-row gap-8 relative z-10">
              <div className="w-16 h-16 bg-gradient-to-br from-secondary to-yellow-600 text-white rounded-2xl flex items-center justify-center shrink-0 shadow-lg transform group-hover:rotate-12 transition-transform duration-300">
                <i className="fas fa-band-aid text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="font-display font-bold text-2xl text-slate-900 dark:text-white mb-3">
                  Root Canal Treatment (Endodontic)
                </h3>
                <p className="text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
                  Save your natural tooth with our advanced root canal therapy. We use modern microscopic techniques to ensure the procedure is comfortable and effective, removing infection while preserving your smile.
                </p>
                <a className="inline-flex items-center text-primary font-bold text-sm hover:text-primaryDark transition-colors group/link" href="#contact">
                  Schedule Consultation <i className="fas fa-arrow-right ml-2 group-hover/link:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
